import { motion } from 'framer-motion';
import styled from 'styled-components';

import { mediaTablet } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

interface TextContainerProps {
  align: 'left' | 'right';
}

export const Container = styled(motion.article)`
  display: grid;
  grid-template-columns: 1fr;

  ${mediaTablet(`
    grid-template-columns: repeat(12, 1fr);
  `)}
`;

export const TitleWrapper = styled.div`
  position: relative;
  margin-bottom: 175rem;

  &::after {
    content: '';
    position: absolute;
    top: 96rem;
    left: 0;
    width: 60px;
    border: 4px solid ${colors.alizarinCrimson};
  }

  ${mediaTablet(`
    margin-bottom: 92rem;

    &::after {
      top: 72rem;
    }
  `)}
`;

export const TextContainer = styled.div<TextContainerProps>`
  ${({ align = 'right' }) =>
    mediaTablet(`
    ${align === 'right' ? 'grid-column: 7/12' : 'grid-column: 2/7'};
  `)}
`;
